import { selectAuth } from "@redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { ComponentEventActivity } from "src/Components/EventActivity";

export const PageEventActivity = () => {
    const { userInfo } = useSelector(selectAuth);

    return <ComponentEventActivity userInfo={userInfo} />;
};
